var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { Tooltip, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { Button, ButtonMode } from '../Components/Button';
import { StyledDialog } from '../Components/Dialog/StyledDialog';
import { CloseIcon, CloudCircleIcon, CloudDoneIcon, CloudUploadIcon } from '../Components/Icons';
import { heading, white50 } from '../Styles/Colours';
import { EditMedication } from './EditMedication';
import { CdsStatus, MedicationStatus, MedicationType } from '../Contracts/MedicationModels';
import styles from './EditMedicationDialog.module.css';
import { DeleteMedicationDialog } from '../MedicationSummary/DeleteMedicationDialog';
import { useError } from '../Components/ErrorBoundary';
import { useHistory } from 'react-router';
import { ClinicalDecisionSupportDialog } from '../ClinicalDecisionSupport/ClinicalDecisionSupportDialog';
import { useMedicationSettings } from '../Config/MedicationConfig';
export var EditMedicationDialog = function (props) {
    var _a, _b, _c, _d, _e, _f;
    var throwError = useError();
    var _g = __read(useState(false), 2), showDeleteMedication = _g[0], setShowDeleteMedication = _g[1];
    var _h = __read(useState(false), 2), ignoreFormValidation = _h[0], setIgnoreFormValidation = _h[1];
    var _j = __read(useState(false), 2), showClinicalDecisionSupportDialog = _j[0], setShowClinicalDecisionSupportDialog = _j[1];
    var _k = __read(useState(props.patientMedication), 2), patientMedication = _k[0], setPatientMedication = _k[1];
    var history = useHistory();
    var fromReprescribe = !!((_a = history.location.state) === null || _a === void 0 ? void 0 : _a.fromReprescribe);
    var header = fromReprescribe ? 'Re-prescribe medication' : 'Draft medication';
    var medicationSettings = useMedicationSettings();
    var decisionSupportSettings = medicationSettings.settings.decisionSupportSettings;
    var patientMedications = [];
    patientMedications.push(props.patientMedication);
    useEffect(function () {
        var _a;
        setShowClinicalDecisionSupportDialog(props.patientMedication.status === MedicationStatus.Draft &&
            props.patientMedication.medicationType == MedicationType.EnrmcScript &&
            ((_a = props.patientMedication.cdsDetail) === null || _a === void 0 ? void 0 : _a.status) != CdsStatus.Noted &&
            (decisionSupportSettings.medicationToConditionEnabled ||
                decisionSupportSettings.medicationToAllergiesEnabled ||
                decisionSupportSettings.medicationToMedicationEnabled ||
                decisionSupportSettings.medicationToPregnancyEnabled));
    }, []);
    var isActivePrescriber = (_d = (_c = (_b = props.currentProvider) === null || _b === void 0 ? void 0 : _b.prescriberDetails) === null || _c === void 0 ? void 0 : _c.activePrescriber) !== null && _d !== void 0 ? _d : false;
    var isAdjustMedication = false;
    // We have disable Adjust medication for A&D 1.2.7, we will enable this afterward.
    //const isAdjustMedication =
    //    isActivePrescriber &&
    //    props.patientMedication.status === MedicationStatus.Finalised &&
    //    (props.patientMedication.medicationType === MedicationType.EnrmcScript ||
    //        props.patientMedication.medicationType === MedicationType.ComplementaryTherapyOrder);
    var content = (React.createElement(EditMedication, __assign({}, props, { patientMedication: patientMedication, currentProvider: props.currentProvider, isAdjustMedication: isAdjustMedication, ignoreFormValidation: ignoreFormValidation, onCancel: props.onCancel, onUpdate: props.onUpdate, onDelete: function () { return setShowDeleteMedication(true); }, handleErrorOnDelete: function (err) {
            throwError(err);
            props.onUpdate();
        } })));
    return (React.createElement(React.Fragment, null,
        props.patientMedication.status === MedicationStatus.Draft ? (React.createElement(StyledDialog, { open: true, size: 'lg', modal: true, testId: 'draft-medication', titleComponent: React.createElement("div", { className: styles.title },
                React.createElement(CloudUploadIcon, { size: '48', color: heading }),
                React.createElement("div", { className: styles.titleText },
                    React.createElement(Typography, { variant: 'h6', color: 'inherit' },
                        React.createElement("div", { className: styles.tileFont }, header))),
                React.createElement("div", null,
                    React.createElement(Tooltip, { title: 'Delete' },
                        React.createElement("span", null,
                            React.createElement(Button, { iconOnly: true, onClick: function () { return setShowDeleteMedication(true); }, mode: ButtonMode.text, noShadowOnHover: true, subtleShadeOnHover: true, testId: 'close-draft-title' },
                                React.createElement(CloseIcon, { size: '20', color: heading, noPadding: true })))))), contentComponent: content })) : (React.createElement(StyledDialog, { open: true, size: 'lg', modal: true, testId: 'edit-medication', title: 'Medication details', titleBarLeft: props.patientMedication.status === MedicationStatus.Stopped ? (React.createElement(CloudCircleIcon, { size: '48', color: 'white' })) : (React.createElement(CloudDoneIcon, { size: '48', color: 'white' })), titleBarRight: React.createElement(Tooltip, { title: 'Close' },
                React.createElement(Button, { iconOnly: true, onClick: props.onCancel, noShadowOnHover: true, subtleShadeOnHover: true, testId: 'close-edit-medication-dialog' },
                    React.createElement(CloseIcon, { size: '20', color: white50, noPadding: true }))), contentComponent: content })),
        showDeleteMedication && (React.createElement(DeleteMedicationDialog, { medicationName: props.patientMedication.name, medicationId: props.patientMedication.id, onDelete: function () {
                setShowDeleteMedication(false);
                setIgnoreFormValidation(true);
                props.onUpdate();
            }, handleErrorOnDelete: function (err) {
                throwError(err);
                props.onUpdate();
            }, setShowDeleteMedicationDialog: function (show) {
                setShowDeleteMedication(show);
            } })),
        showClinicalDecisionSupportDialog && (React.createElement(ClinicalDecisionSupportDialog, { onDelete: function () {
                setShowDeleteMedication(false);
                setIgnoreFormValidation(true);
                props.onUpdate();
            }, handleErrorOnDelete: function (err) {
                throwError(err);
                props.onUpdate();
            }, setShowClinicalDecisionSupportDialog: function (show) {
                setShowClinicalDecisionSupportDialog(show);
            }, setShowDeleteMedication: function (show) {
                setShowDeleteMedication(show);
            }, setDeleteMedicationId: function (id) {
                '';
            }, setDeleteMedicationName: function (name) {
                '';
            }, onUpdate: props.onUpdate, isReprescribe: fromReprescribe, setIgnoreFormValidation: function (val) {
                setIgnoreFormValidation(val);
            }, patient: props.patient, encounter: props.encounter, medication: { medicationCode: ((_f = (_e = props.patientMedication) === null || _e === void 0 ? void 0 : _e.medication) === null || _f === void 0 ? void 0 : _f.code) || '', patientMedicationId: props.patientMedication.id }, setCdsResponse: function (response) {
                var patientMedicationUpdated = __assign(__assign({}, patientMedication), { cdsDetail: {
                        notedBy: response.notedBy,
                        notedOn: response.notedOn,
                        status: response.status,
                        patientMedicationId: response.patientMedicationId
                    } });
                setPatientMedication(patientMedicationUpdated);
            } }))));
};
